import { Pipe, PipeTransform } from '@angular/core';
import { Files } from '../../common/util/files';

@Pipe({ name: 'fileSize' })
export class FileSizePipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    return args ? Files.formatBytes(obj, 2, args) : Files.formatBytes(obj);
  }
}
